// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/iconfont/iconfont.css'
import global from '@/components/global'
import htmlToPdf from '@/utils/htmlToPdf'

Vue.use(htmlToPdf)

Vue.config.productionTip = false
Vue.prototype.GLOBAL = global

import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = process.env.API_URL
Vue.prototype.$axios = axios


// router.beforeEach((to,from,next)=>{
// 	if(to.meta.title){
// 		document.title=to.meta.title
// 	}
// 	next()
// })
router.beforeEach ((to, from, next) => {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS && to.path !== location.pathname) {
    // 此处不可使用location.replace
    location.assign(to.fullPath)
  } else {
    next()
  }
});

// 引入组件
import '../static/weui/weui.css'

import WeVue from 'we-vue'
import 'we-vue/lib/style.css'
Vue.use(WeVue)

import VueWeui from 'vue-weui'
Vue.use(VueWeui)

//import css
import 'vue-beauty/package/style/vue-beauty.min.css'

//import components
import vueBeauty from 'vue-beauty'
Vue.use(vueBeauty)

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import FormMaking from 'form-making'
import 'form-making/dist/FormMaking.css'
Vue.use(FormMaking)
// import { DatePicker } from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(DatePicker);
// import { Select } from 'element-ui';
// Vue.use(Select);

// import { Option } from 'element-ui';
// Vue.use(Option);

// import { Cascader } from 'element-ui';
// Vue.use(Cascader);
// import { Button } from 'element-ui';
// Vue.use(Button);
// import { Input } from 'element-ui';
// Vue.use(Input);
// import { Checkbox } from 'element-ui';
// Vue.use(Checkbox);
// import { CheckboxButton } from 'element-ui';
// Vue.use(CheckboxButton);

// import { Table } from 'element-ui';
// Vue.use(Table);
// import { TableColumn } from 'element-ui';
// Vue.use(TableColumn);

import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue, {
    msgtime: 3,//目前只有一项，即msg方法的默认消失时间，单位：秒
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js